import {Component} from "../interface/component";

export class AccordionComponent implements Component {

    private $root:JQuery;
    private $triggers:JQuery;
    private $contents:JQuery;
    private noAutoShow: boolean = false;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$triggers = this.$root.find('.js-accordion-trigger');
        this.$contents = this.$root.find('.js-accordion-content');
        this.noAutoShow = this.$root.data('no-auto-show');
    }

    init() {
        if (this.$triggers.length > 1 || this.noAutoShow) {
            this.$triggers.on({click: this.clickHandler});
            this.$triggers.first().removeClass('c-trigger--active');
            this.$contents.hide();
        }else{
            this.$triggers.attr('aria-expanded', 'true')
                .addClass('.c-trigger--active');
        }
    }

    clickHandler = (ev:Event) => {
        let element = $(ev.currentTarget);
        let targetSelector = '#' + element.attr('aria-controls');
        let target = $(targetSelector);
        let isActive = element.hasClass('c-trigger--active');
        let toSlideUp = this.$contents.not(targetSelector);
        let otherTriggers = this.$triggers.not('#' + element.attr('id'));

        otherTriggers.attr('aria-expanded', 'false')
            .removeClass('c-trigger--active');
        toSlideUp.slideUp(200);

        if (!isActive) {
            element.attr('aria-expanded', 'true')
                .addClass('c-trigger--active');
            target.slideDown(200);
        }else{
            element.attr('aria-expanded', 'false')
                .removeClass('c-trigger--active');
            target.slideUp(200);
        }
    }
}
